import Anmelden from "./components/Anmelden.vue";
import Import from "./components/einstellungen/Import.vue";
import NotAllowed from "./components/NotAllowedView.vue";

import Uebersicht from "./components/uebersicht/Uebersicht.vue";

import Wareneingang from "./components/wareneingang/Wareneingang.vue";

import OnTheRoad from "./components/onTheRoad/OnTheRoad.vue";
import OnTheRoadReiter from "./components/onTheRoad/OnTheRoadReiter.vue";
import BearbeiteAjaOnTheRoad from "./components/onTheRoad/bearbeiten/BearbeiteAjaOnTheRoad.vue";

import Altbestaende from "./components/altbestaende/Altbestaende.vue";
import AltbestaendeReiter from "./components/altbestaende/AltbestaendeReiter.vue";
import BearbeiteAltbestaende from "./components/altbestaende/bearbeiten/BearbeiteAltbestaende.vue";

import BuKundenHerstellerUmsaetze from "./components/bu_kunden_hersteller_umsaetze/BuKundenHerstellerUmsaetze.vue";
import BuKundenHerstellerUmsaetzeReiter from "./components/bu_kunden_hersteller_umsaetze/BuKundenHerstellerUmsaetzeReiter.vue";
import ZeigeBuKundenHerstellerUmsaetze from "./components/bu_kunden_hersteller_umsaetze/edit/ZeigeBuKundenHerstellerUmsaetze.vue";
import ErstelleBuKundenHerstellerUmsaetze from "./components/bu_kunden_hersteller_umsaetze/edit/ErstelleBuKundenHerstellerUmsaetze.vue";
import BearbeiteBuKundenHerstellerUmsaetze from "./components/bu_kunden_hersteller_umsaetze/edit/BearbeiteBuKundenHerstellerUmsaetze.vue";

import Herstellerumsaetze from "./components/herstellerumsaetze/Herstellerumsaetze.vue";
import HerstellerumsaetzeReiter from "./components/herstellerumsaetze/HerstellerumsaetzeReiter.vue";
import ZeigeBusinessUnits from "./components/herstellerumsaetze/businessunits/ZeigeBusinessUnits.vue";
import ErstelleBusinessUnit from "./components/herstellerumsaetze/businessunits/ErstelleBusinessUnit.vue";
import BearbeiteBusinessUnit from "./components/herstellerumsaetze/businessunits/BearbeiteBusinessUnit.vue";

import Kundenumsaetze from "./components/kundenumsaetze/Kundenumsaetze.vue";
import KundenumsaetzeReiter from "./components/kundenumsaetze/KundenumsaetzeReiter.vue";
import ZeigeKundenbetreuer from "./components/kundenumsaetze/kundenbetreuer/ZeigeKundenbetreuer.vue";
import ErstelleKundenbetreuer from "./components/kundenumsaetze/kundenbetreuer/ErstelleKundenbetreuer.vue";
import BearbeiteKundenbetreuer from "./components/kundenumsaetze/kundenbetreuer/BearbeiteKundenbetreuer.vue";

import Amazonumsaetze from "./components/amazonumsaetze/Amazonumsaetze.vue";
import AmazonumsaetzeReiter from "./components/amazonumsaetze/AmazonumsaetzeReiter.vue";
import ZeigeAmazonLaender from "./components/amazonumsaetze/laender/ZeigeAmazonLaender.vue";
import ErstelleAmazonLand from "./components/amazonumsaetze/laender/ErstelleAmazonLand.vue";
import BearbeiteAmazonLand from "./components/amazonumsaetze/laender/BearbeiteAmazonLand.vue";

import Kunden from "./components/einstellungen/kunden/Kunden.vue";
import ZeigeKunden from "./components/einstellungen/kunden/ZeigeKunden.vue";
import ErstelleKunde from "./components/einstellungen/kunden/ErstelleKunde.vue";
import BearbeiteKunde from "./components/einstellungen/kunden/BearbeiteKunde.vue";
import ImportiereKunden from "./components/einstellungen/kunden/ImportiereKunden.vue";

import Hersteller from "./components/einstellungen/hersteller/Hersteller.vue";
import ZeigeHersteller from "./components/einstellungen/hersteller/ZeigeHersteller.vue";
import ErstelleHersteller from "./components/einstellungen/hersteller/ErstelleHersteller.vue";
import BearbeiteHersteller from "./components/einstellungen/hersteller/BearbeiteHersteller.vue";
import ImportiereHersteller from "./components/einstellungen/hersteller/ImportiereHersteller.vue";

import Laender from "./components/einstellungen/laender/Laender.vue";
import ZeigeLaender from "./components/einstellungen/laender/ZeigeLaender.vue";
import ErstelleLand from "./components/einstellungen/laender/ErstelleLand.vue";
import BearbeiteLand from "./components/einstellungen/laender/BearbeiteLand.vue";

import Lagerwerte from "./components/lagerwerte/Lagerwerte.vue";
import BearbeiteLagerHersteller from "./components/lagerwerte/bearbeiten/BearbeiteLagerHersteller.vue";
import LagerwerteTabelle from "./components/lagerwerte/LagerwerteTabelle.vue";

import HerstellerKundenumsaetze from "./components/herstellerumsaetze_kunden/HerstellerKundenumsaetze.vue";
import ZeigeHerstellerKundenumsaetze from "./components/herstellerumsaetze_kunden/edit/ZeigeHerstellerKundenumsaetze.vue";
import ErstelleHerstellerKundenumsaetze from "./components/herstellerumsaetze_kunden/edit/ErstelleHerstellerKundenumsaetze.vue";
import BearbeiteHerstellerKundenumsaetze from "./components/herstellerumsaetze_kunden/edit/BearbeitenHerstellerKundenumsaetze.vue";
import HerstellerKundenumsaetzeReiter from "./components/herstellerumsaetze_kunden/HerstellerKundenumsaetzeReiter.vue";
import SignedInView from "./components/SignedInView.vue";
import VizrtOverviewView from "./components/vizrt-bonus/VizrtOverviewView.vue";

export default [
  {
    path: "*",
    redirect: "/anmelden",
  },
  {
    path: "/",
    redirect: "/anmelden",
  },
  {
    path: "/token/:token",
    component: Anmelden,
  },
  {
    path: "/anmelden",
    name: "Anmelden",
    component: Anmelden,
  },
  {
    path: "/notallowed",
    name: "NotAllowed",
    component: NotAllowed,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/x/uebersicht",
    component: SignedInView,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "Uebersicht",
        component: Uebersicht,
      },
      {
        path: "/x/wareneingang",
        component: Wareneingang,
        name: "Wareneingang",
      },
      {
        path: "/x/aja-ontheroad",
        component: OnTheRoad,
        children: [
          {
            path: "",
            component: OnTheRoadReiter,
            name: "OnTheRoad",
          },
          {
            path: "/x/aja-ontheroad/bearbeiten",
            component: BearbeiteAjaOnTheRoad,
            name: "BearbeiteAjaOnTheRoad",
          },
        ],
      },
      {
        path: "/x/altbestaende",
        component: Altbestaende,
        children: [
          {
            path: "",
            component: AltbestaendeReiter,
            name: "Altbestaende",
          },
          {
            path: "/x/altbestaende/bearbeiten",
            component: BearbeiteAltbestaende,
            name: "BearbeiteAltbestaende",
          },
        ],
      },
      {
        path: "/x/bukundenherstellerumsaetze",
        component: BuKundenHerstellerUmsaetze,
        children: [
          {
            path: "",
            component: BuKundenHerstellerUmsaetzeReiter,
            name: "BuKundenHerstellerUmsaetze",
          },
          {
            path: "/x/bukundenherstellerumsaetze/bearbeiten",
            component: ZeigeBuKundenHerstellerUmsaetze,
            name: "ZeigeBuKundenHerstellerUmsaetze",
          },
          {
            path: "/x/bukundenherstellerumsaetze/erstellen",
            component: ErstelleBuKundenHerstellerUmsaetze,
            name: "ErstelleBuKundenHerstellerUmsaetze",
          },
          {
            path: "/x/bukundenherstellerumsaetze/bearbeiten/:id",
            component: BearbeiteBuKundenHerstellerUmsaetze,
            name: "BearbeiteBuKundenHerstellerUmsaetze",
          },
        ],
      },
      {
        path: "/x/herstellerumsaetze",
        component: Herstellerumsaetze,
        children: [
          {
            path: "",
            component: HerstellerumsaetzeReiter,
            name: "Herstellerumsaetze",
          },
          {
            path: "/x/herstellerumsaetze/bearbeiten",
            component: ZeigeBusinessUnits,
            name: "ZeigeBusinessUnits",
          },
          {
            path: "/x/herstellerumsaetze/erstellen",
            component: ErstelleBusinessUnit,
            name: "ErstelleBusinessUnit",
          },
          {
            path: "/x/herstellerumsaetze/bearbeiten/:id",
            component: BearbeiteBusinessUnit,
            name: "BearbeiteBusinessUnit",
          },
        ],
      },
      {
        path: "/x/kundenumsaetze",
        component: Kundenumsaetze,
        children: [
          {
            path: "",
            component: KundenumsaetzeReiter,
            name: "Kundenumsaetze",
          },
          {
            path: "/x/kundenumsaetze/bearbeiten",
            component: ZeigeKundenbetreuer,
            name: "ZeigeKundenbetreuer",
          },
          {
            path: "/x/kundenumsaetze/erstellen",
            component: ErstelleKundenbetreuer,
            name: "ErstelleKundenbetreuer",
          },
          {
            path: "/x/kundenumsaetze/bearbeiten/:id",
            component: BearbeiteKundenbetreuer,
            name: "BearbeiteKundenbetreuer",
          },
        ],
      },
      {
        path: "/x/amazonumsaetze",
        component: Amazonumsaetze,
        children: [
          {
            path: "",
            component: AmazonumsaetzeReiter,
            name: "Amazonumsaetze",
          },
          {
            path: "/x/amazonumsaetze/bearbeiten",
            component: ZeigeAmazonLaender,
            name: "ZeigeAmazonLaender",
          },
          {
            path: "/x/amazonumsaetze/erstellen",
            component: ErstelleAmazonLand,
            name: "ErstelleAmazonLand",
          },
          {
            path: "/x/amazonumsaetze/bearbeiten/:id",
            component: BearbeiteAmazonLand,
            name: "BearbeiteAmazonLand",
          },
        ],
      },
      {
        path: "/x/einstellungen/kunden",
        component: Kunden,
        children: [
          {
            path: "",
            component: ZeigeKunden,
            name: "Kunden",
          },
          {
            path: "/x/einstellungen/kunden/erstellen",
            component: ErstelleKunde,
            name: "ErstelleKunde",
          },
          {
            path: "/x/einstellungen/kunden/bearbeiten/:id",
            component: BearbeiteKunde,
            name: "BearbeiteKunde",
          },
          {
            path: "/x/einstellungen/kunden/importieren",
            component: ImportiereKunden,
            name: "ImportiereKunden",
          },
        ],
      },
      {
        path: "/x/einstellungen/hersteller",
        component: Hersteller,
        children: [
          {
            path: "",
            component: ZeigeHersteller,
            name: "Hersteller",
          },
          {
            path: "/x/einstellungen/hersteller/erstellen",
            component: ErstelleHersteller,
            name: "ErstelleHersteller",
          },
          {
            path: "/x/einstellungen/hersteller/bearbeiten/:id",
            component: BearbeiteHersteller,
            name: "BearbeiteHersteller",
          },
          {
            path: "/x/einstellungen/hersteller/importieren",
            component: ImportiereHersteller,
            name: "ImportiereHersteller",
          },
        ],
      },
      {
        path: "/x/einstellungen/laender",
        component: Laender,
        children: [
          {
            path: "",
            component: ZeigeLaender,
            name: "Laender",
          },
          {
            path: "/x/einstellungen/laender/erstellen",
            component: ErstelleLand,
            name: "ErstelleLand",
          },
          {
            path: "/x/einstellungen/laender/bearbeiten/:id",
            component: BearbeiteLand,
            name: "BearbeiteLand",
          },
        ],
      },
      {
        path: "/x/lagerwerte",
        component: Lagerwerte,
        children: [
          {
            path: "",
            component: LagerwerteTabelle,
            name: "Lagerwerte",
          },
          {
            path: "/x/lagerwerte/bearbeiten",
            component: BearbeiteLagerHersteller,
            name: "BearbeiteLagerHersteller",
          },
        ],
      },
      {
        path: "/x/herstellerkundenumsaetze",
        component: HerstellerKundenumsaetze,
        children: [
          {
            path: "",
            component: HerstellerKundenumsaetzeReiter,
            name: "HerstellerKundenumsaetze",
          },
          {
            path: "/x/herstellerkundenumsaetze/bearbeiten/:id",
            component: BearbeiteHerstellerKundenumsaetze,
            name: "BearbeiteHerstellerKundenumsaetze",
          },
          {
            path: "/x/herstellerkundenumsaetze/erstellen",
            component: ErstelleHerstellerKundenumsaetze,
            name: "ErstelleHerstellerKundenumsaetze",
          },
          {
            path: "/x/herstellerkundenumsaetze/zeige",
            component: ZeigeHerstellerKundenumsaetze,
            name: "ZeigeHerstellerKundenumsaetze",
          },
        ],
      },
      {
        path: "/x/einstellungen/import",
        component: Import,
        name: "Import",
      },
      {
        path: "/vizrt-bonus",
        component: VizrtOverviewView,
        name: 'VizrtBonusTool',
        meta: { requiresAuth: true },
      },
    ],
  },
];
